/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.className : a tailwind class the would be implemented on span tag
 * @param props.strokeWidth : set the strokeWidth with px css
 */

interface PersonProps {
  color?: string
  className?: string
  strokeWidth?: string
}

const Cancel = (props: PersonProps) => {
  const { color = '#364152', strokeWidth = '1' } = props

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6663 1.33203L1.33301 14.6654M14.6663 14.6654L1.33301 1.33203"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Cancel
